const origins = {
  0: 'Nacional',
  1: 'Estrangeira com importação direta',
  2: 'Estrangeira adquirida no mercado interno',
  3: 'Nacional, mercadoria ou bem com conteúdo de importação superior a 40% (quarenta por cento) e inferior ou igual a 70% (setenta por cento)',
  4: 'Nacional, cuja produção tenha sido feita em conformidade com os processos produtivos básicos de que tratam o Decreto-Lei nº 288/67, e as Leis n.º 8.248/91, 8.387/91, 10.176/01 e 11.484/07',
  5: 'Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40% (quarenta por cento)',
  6: 'Estrangeira - Importação direta, sem similar nacional, constante em lista de Resolução CAMEX e gás natural',
  7: 'Estrangeira - Adquirida no mercado interno, sem similar nacional, constante em lista de Resolução CAMEX e gás natural',
  8: 'Nacional, mercadoria ou bem com Conteúdo de Importação superior a 70% (setenta por cento)'
};

export default origins;
